import { jsxs as h, jsx as l } from "react/jsx-runtime";
const r = (v) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...v,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M39.438 12.436v-2.373c0-1.353-1.101-2.454-2.454-2.454h-9.968a2.456 2.456 0 0 0-2.454 2.454v2.373h-11.2a4.072 4.072 0 0 0-4.067 4.067v3.586c0 2.25 1.83 4.08 4.08 4.08h.356l2.362 29.74a4.363 4.363 0 0 0 4.327 3.998h24.535l-1.064-3.974 4.102-1.1 2.276-28.664h4.436V12.436H39.438Zm-12.876-2.373c0-.25.204-.454.454-.454h9.968c.25 0 .454.203.454.454v2.373H26.562v-2.373Zm17.333 43.844H20.42a.343.343 0 0 1-.34-.314l-2.497-31.446h28.834l-2.522 31.76Zm6.81-33.76H13.32a.08.08 0 0 1-.024-.058v-3.586c0-.037.03-.067.067-.067h37.341v3.71Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m39.83 26.752-1.973.529-.027-.103v23.285l2-.536V26.752ZM33.166 26.752l-1.972.529-.028-.103v23.285l2-.536V26.752ZM26.503 26.752l-1.973.529-.027-.103v23.285l2-.536V26.752Z"
        }
      )
    ]
  }
);
export {
  r as Bin
};
